import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62064a09")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "sys-switch",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleToggleSwitch && $setup.handleToggleSwitch(...args)))
  }, [
    _createVNode("div", {
      class: ["sys-switch__background", $props.modelValue ? 'background-active' : '']
    }, null, 2),
    _createVNode("div", {
      class: ["sys-switch__circle", $props.modelValue ? 'circle-active' : '']
    }, null, 2)
  ]))
})